module.exports = __webpack_public_path__ + "static/media/step4.e40bf7fb.svg";